import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1)
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "bg-transparent text-primary transition p-0 border-0"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-search-interface-symbol" })
], -1)
const _hoisted_7 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_8 = { class: "table-responsive" }
const _hoisted_9 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Question "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Catégorie Faq "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Tag "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text pe-0"
    }, "ACTIONS")
  ])
], -1)
const _hoisted_11 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_16 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_17 = { class: "col-12" }
const _hoisted_18 = { class: "col-6" }
const _hoisted_19 = { class: "badge badge-outline-danger text-outline-primary" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete icon-position" }, null, -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text pe-0" }
const _hoisted_24 = { class: "dropdown" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", {
  class: "badge text-white bg-primary fs-15 dropdown-toggle",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createTextVNode(" Actions "),
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
], -1)
const _hoisted_26 = { class: "dropdown-menu" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_28 = ["onClick"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-plus lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-eye lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_31 = ["onClick"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_33 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!
  const _component_AddNewTagModal = _resolveComponent("AddNewTagModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
            to: "/ajouter-faq"
          }, {
            default: _withCtx(() => [
              _hoisted_4,
              _createTextVNode(" Ajouter un faq ")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("form", {
            class: "search-box position-relative me-15",
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
              onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
              class: "form-control shadow-none text-black rounded-0 border-0",
              placeholder: "Rechercher un faq"
            }, null, 544), [
              [_vModelText, _ctx.searchTerm]
            ]),
            _hoisted_6
          ], 32)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("table", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.faqs, (faq, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_11, [
                    _createElementVNode("div", {
                      innerHTML: faq.question.slice(0, 20) + '...'
                    }, null, 8, _hoisted_12)
                  ]),
                  _createElementVNode("td", _hoisted_13, [
                    _createElementVNode("div", {
                      innerHTML: faq.reponse.slice(0, 20) + '...'
                    }, null, 8, _hoisted_14)
                  ]),
                  _createElementVNode("td", _hoisted_15, _toDisplayString(faq?.categorieFaq?.nom.length > 20 ? faq?.categorieFaq?.nom.slice(0, 20) + ' ...' : faq?.categorieFaq?.nom), 1),
                  _createElementVNode("td", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(faq.faqtags, (faqtag) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: faqtag.id,
                          class: "badge-container"
                        }, [
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("span", _hoisted_19, [
                              _createTextVNode(_toDisplayString(faqtag.tag?.nom) + " ", 1),
                              _createElementVNode("a", {
                                href: "javascript:void(0);",
                                class: "tag-delete-link text-outline-danger",
                                onClick: ($event: any) => (_ctx.suppression(faqtag.id, faq?.faqtags, 'faqtag', `le tag ${faqtag.tag.nom}`))
                              }, _hoisted_22, 8, _hoisted_20)
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _hoisted_25,
                      _createElementVNode("ul", _hoisted_26, [
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, {
                            to: { name: 'EditFaqPage', params: { id: faq.id } },
                            class: "dropdown-item d-flex align-items-center"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_27,
                              _createTextVNode("Modifier")
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: "dropdown-item d-flex align-items-center",
                            href: "#",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#AddNewTagModal",
                            onClick: ($event: any) => (_ctx.openAddNewTagModal(faq))
                          }, [
                            _hoisted_29,
                            _createTextVNode(" Ajouter de (s) tag (s) ")
                          ], 8, _hoisted_28)
                        ]),
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, {
                            to: { name: 'ViewFaqPage', params: { id: faq.id } },
                            class: "dropdown-item d-flex align-items-center"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_30,
                              _createTextVNode("Détails ")
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: "dropdown-item d-flex align-items-center",
                            href: "javascript:void(0);",
                            onClick: ($event: any) => (_ctx.suppression(faq.id,_ctx.faqs,'faqs',`la faq ${faq.id}`))
                          }, [
                            _hoisted_32,
                            _createTextVNode(" Supprimer ")
                          ], 8, _hoisted_31)
                        ])
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createVNode(_component_PaginationComponent, {
            page: _ctx.page,
            totalPages: _ctx.totalPages,
            totalElements: _ctx.totalElements,
            limit: _ctx.limit,
            onPaginate: _ctx.handlePaginate
          }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
        ])
      ])
    ]),
    _createVNode(_component_AddNewTagModal, {
      selectedFaq: _ctx.selectedFaq,
      selectedFaqId: _ctx.selectedFaqId
    }, null, 8, ["selectedFaq", "selectedFaqId"])
  ], 64))
}